import React, {useState, useEffect} from 'react';
import { Col, Row, Image } from 'react-bootstrap';
import { useMsal} from '@azure/msal-react';
import { ApiProvider } from '../../providers/apiProvider';
import { useTranslation } from 'react-i18next';
import { InputField, SelectField, UploadField, useFormContext } from 'clayco-controls';
import Resizer from "react-image-file-resizer";

const VoluntaryInfo = ({ mostRecentYesMatchedAssociate, showLoading }) => {
    const {t} = useTranslation();
    const { setValue, getValues } = useFormContext();
    const {instance, accounts} = useMsal();
    const _api = new ApiProvider(instance, accounts[0]);
    const [ethnicities, setEthnicities] = useState([]);
    const [genders, setGenders] = useState([]);
    const [veteran, setVeteran] = useState([{id: 1, name: 'Yes', value: true}, {id: 2, name: 'No', value: false}]);

    const handleUpload =(e)=>{
        e.preventDefault();

        resizeFile(e.target.files[0]).then((result) => {
            setValue(`voluntaryInfo.profilePhotoData`, result);
        })
    };

    const resizeFile = (file) => new Promise(resolve => {
        Resizer.imageFileResizer(file, 2048, 2048, 'JPEG', 50, 0,
        uri => {
          resolve(uri);
        }, 'file' );
    });

    useEffect(()=> {
        const loadGenders = async()=>{
            showLoading(true);
            let genders = await _api.Get(`gender/getall/${window.language}`);
            showLoading(false);
            if (!genders.error) {
                setGenders(genders);
                const selectedGender = genders?.find(option => option.id === mostRecentYesMatchedAssociate?.genderId);
                setValue('voluntaryInfo.gender', selectedGender?.id);
            }
        };

        const loadEthnicity = async()=> {
            showLoading(true);
            let ethnicities = await _api.Get(`ethnicity/getall/${window.language}`);
            showLoading(false);
            if (!ethnicities.error) {
                setEthnicities(ethnicities);
                const selectedEthnicity = ethnicities?.find(option => option.id === mostRecentYesMatchedAssociate?.ethnicityId);
                setValue('voluntaryInfo.ethnicity', selectedEthnicity?.id);
            }
        }

        loadGenders();
        loadEthnicity();

        const selectedVendor = veteran.find(option => option.value === mostRecentYesMatchedAssociate?.isVeteran);
        const zipCode = mostRecentYesMatchedAssociate?.postalCode == null ? '' : mostRecentYesMatchedAssociate?.postalCode;
        setValue('voluntaryInfo.veteran', selectedVendor?.id);
        setValue('voluntaryInfo.zipCode', zipCode);

    }, [window.language, mostRecentYesMatchedAssociate])

    return(
        <>
        <div className='card p-0 my-3'>
            <h6 className="card-header text-start">
            {t('Voluntary Information')}
            </h6>
            <div className='card-body'>
            <div className='card-subtitle mb-2 text-muted fst-italic'>
                {t('VoluntaryNotice')}
                </div>           
            <Row>
                <Col>
                    <SelectField placeholder={' '}label={t('Ethnicity')} name={'voluntaryInfo.ethnicity'} options={ethnicities}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <SelectField placeholder={' '} label={t('Gender')} name={'voluntaryInfo.gender'} options={genders}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <SelectField placeholder={' '} label={t('Veteran')} name={'voluntaryInfo.veteran'} options={veteran}/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <InputField placeholder={' '} label={t('Zip Code')} name={'voluntaryInfo.zipCode'} type='number'/>
                </Col>
            </Row>
            <Row>
                <Col>
                    <table className='w-100' ><tbody>
                    <tr>
                        <td className='w-100'>
                            <UploadField className='p-10' label={t('Photo')} name={'voluntaryInfo.profilePhoto'} onChange={handleUpload} filters={'.jpg, .png, .jpeg, .heic'} />
                        </td>
                        <td className='align-bottom' >
                        { mostRecentYesMatchedAssociate?.photoPath 
                            ? <Image width="48" height="48" src={mostRecentYesMatchedAssociate?.photoPath} roundedCircle={true} />
                            : <></>
                        }
                        </td>
                    </tr>
                    </tbody></table>
                </Col>
            </Row>
            </div>
        </div>
        </>
    )
}

export default VoluntaryInfo;